import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router";
import { useComponentTranslation } from "@/services/i18n";
import { FaCode, FaArrowLeft, FaExternalLinkAlt } from "react-icons/fa";
import API from "@/services/api";
import PublishToggle from "./components/publish-toggle";

const translations = {
  en: {
    title: "Embed Job",
    back: "Back to channels",
    publish: "Publish",
    unpublish: "Unpublish",
    post_published: "Job published successfully",
    post_unpublished: "Job unpublished successfully",
    post_not_enabled: "Failed to publish job",
    loading: "Loading...",
    learn_more: "Learn more about iframe configuration",
  },
  fr: {
    title: "Intégrer l'offre",
    back: "Retour aux canaux",
    publish: "Publier",
    unpublish: "Dépublier",
    post_published: "Offre publiée avec succès",
    post_unpublished: "Offre dépubliée avec succès",
    post_not_enabled: "Échec de la publication",
    loading: "Chargement...",
    learn_more: "En savoir plus sur la configuration iframe",
  },
};

export default function IframeChannel({ job, setJob, posts = [], setPosts }) {
  const { t } = useComponentTranslation(translations);
  const { id: jobId } = useParams();
  const navigate = useNavigate();
  const [channel, setChannel] = useState(null);
  const [loading, setLoading] = useState(true);
  const channelSlug = "iframe";

  useEffect(() => {
    fetchChannel();
  }, []);

  const fetchChannel = async () => {
    try {
      setLoading(true);
      const response = await API.post(`/channel/search`, {
        slug: channelSlug,
        limit: 1,
      });
      if (response.ok && response.data?.[0]) {
        setChannel(response.data[0]);
      }
    } catch (e) {
      console.error("Error fetching channel:", error);
    } finally {
      setLoading(false);
    }
  };

  // Find job post from posts array
  const jobPost = channel ? posts.find((post) => post.channel_id === channel._id) : null;

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          <span className="ml-3 text-gray-600">{t("loading")}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto">
      {/* Back button */}
      <button onClick={() => navigate("..")} className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4">
        <FaArrowLeft className="w-4 h-4" />
        {t("back")}
      </button>

      <div className="bg-white border border-gray-200 rounded-xl p-6">
        <div className="flex items-start gap-4">
          {channel?.logo ? (
            <img src={channel.logo} alt={channel.name} className="w-16 h-16 rounded-lg object-cover shrink-0" />
          ) : (
            <div className="w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center shrink-0">
              <FaCode className="w-8 h-8 text-purple-600" />
            </div>
          )}
          <div className="flex-1">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-2xl font-bold text-gray-900">{channel?.name || t("title")}</h3>
              {channel && <PublishToggle job={job} channel={channel} posts={posts} setPosts={setPosts} />}
            </div>

            <p className="text-sm text-gray-600 mb-6">{channel?.description}</p>

            <div className="flex items-center gap-2">
              <button onClick={() => navigate("/recruiter/organisation/iframe")} className="btn btn-secondary flex items-center gap-2">
                {t("learn_more")}
                <FaExternalLinkAlt className="w-3 h-3" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
